import axios from "axios";
import * as bcrypt from "bcryptjs";
import * as Log from "../../util/SDayslogger";
import { env } from "../../config/env";

export const sendMessage = async (jsonMessage: string, callback: any) => {
  const url: string = env.SERVER_URL + "/messages/sendMessage";
  // "http://localhost:3001/messages/sendMessage";
  const token = await bcrypt.hash(env.SERVER_TOKEN, 10);

  try {
    await axios
      .post(url, JSON.parse(jsonMessage), {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const responseJson = response.data;
        const responseCode = response.status;
        return callback(responseCode, responseJson);
      })
      .catch((error) => {
        //return error callback
        Log.error(
          `error response status : ${
            error.response.status
          } - error response data : ${JSON.stringify(error.response.data)}`
        );
        return callback(error.response.status, error.response.data);
      });
  } catch (err) {
    Log.error("Error Request server : " + err);
    return callback("503", {
      message: `Service Unavailable`,
    });
  }
};

export const sendWABASignUp = async (
  jsonWaba: any,
  callback: (code: number, data: any) => void
) => {
  Log.debug(
    `masuk di sendWABASignUp to server side ${JSON.stringify(jsonWaba)}`
  );
  const url: string = env.SERVER_URL + "/waba/embeddedSignup";
  // "http://localhost:3001/waba/embeddedSignup";
  const token = await bcrypt.hash(env.SERVER_TOKEN, 10);

  try {
    await axios
      .post(url, jsonWaba, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        timeout: 10000,
      })
      .then((response) => {
        Log.debug("Check response : " + JSON.stringify(response));
        Log.debug("Check response.status : " + response?.status);

        const responseJson = response?.data;
        const responseCode = response?.status;
        return callback(responseCode, responseJson);
      })
      .catch((error) => {
        //return error callback
        Log.error("error sendWABASignUp", error);
        return callback(
          error?.response?.status ?? 400,
          error?.response?.data ?? {
            message: `Service Unavailable`,
          }
        );
      });
  } catch (err) {
    Log.error("Error Request server : " + err);
    return callback(503, {
      message: `Service Unavailable`,
    });
  }
};

export const sendWABAVerifyPhoneNumber = async (
  jsonWaba: any,
  callback: (code: number, data: any) => void
) => {
  Log.debug(
    `masuk di sendWABAVerifyPhoneNumber to server side ${JSON.stringify(
      jsonWaba
    )}`
  );
  const url: string = env.SERVER_URL + "/waba/verifyPhone";
  // "http://localhost:3001/waba/createAndSendTemplateMessage";
  const token = await bcrypt.hash(env.SERVER_TOKEN, 10);

  try {
    await axios
      .post(url, jsonWaba, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        Log.debug("Check response : " + JSON.stringify(response));
        Log.debug("Check response.status : " + response.status);

        const responseJson = response.data;
        const responseCode = response.status;
        return callback(responseCode, responseJson);
      })
      .catch((error) => {
        //return error callback
        return callback(error.response.status, error.response.data);
      });
  } catch (err) {
    Log.error("Error Request server : " + err);
    return callback(503, {
      message: `Service Unavailable`,
    });
  }
};

export const sendBlastMessage = async (jsonMessage: Object, callback: any) => {
  const url: string = env.SERVER_URL + "/messages/blast";
  const token = await bcrypt.hash(env.SERVER_TOKEN, 10);

  Log.debug("URL: " + url);

  try {
    await axios
      .post(url, jsonMessage, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const responseJson = response.data;
        const responseCode = response.status;
        return callback(responseCode, responseJson);
      })
      .catch((error) => {
        //return error callback
        return callback(error.response.status, error.response.data);
      });
  } catch (err) {
    Log.error("Error Request server : " + err);
    return callback("503", {
      message: `Service Unavailable`,
    });
  }
};

export const sendCreateTemplate = async (
  jsonMessage: Object,
  whatsappBusinessID: string,
  token: string,
  callback: any
) => {
  Log.debug("Running Send Create Template - SCT");
  Log.debug(jsonMessage, "json message - SCT");

  let url: string = env.SERVER_URL + "/whatsapp/template/create";
  const serverAccessToken = await bcrypt.hash(env.SERVER_TOKEN, 10);
  try {
    await axios
      .post(
        url,
        { jsonMessage, whatsappBusinessID, token },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${serverAccessToken}`,
          },
          timeout: 60000, // 60 seconds for template creation as it can be slow
        }
      )
      .then((response) => {
        Log.debug(
          "komen sendCreateTemplate - Check response : " +
            JSON.stringify(response)
        );
        Log.debug(response, "komen sendCreateTemplate - Check response");

        let responseTemplateID = "";
        if (response.data && response.data.responseTemplateID) {
          responseTemplateID = response.data.responseTemplateID;
        }
        // Extract accountData from server response for client-side template consistency
        const accountData = response.data.accountData || null;
        console.log(`[Template Request] Server accountData:`, accountData);

        return callback(
          responseTemplateID,
          response.data.responseJson ? response.data.responseJson : "",
          response.data.errorMessage ? response.data.errorMessage : "",
          response.data.errorJSON ? response.data.errorJSON : "",
          accountData
        );
      })
      .catch((error) => {
        //return error callback with enhanced timeout handling
        let errorMessage = error.message;

        // Provide more helpful error messages for timeout issues
        if (
          error.code === "ECONNABORTED" &&
          error.message.includes("timeout")
        ) {
          errorMessage = `Template creation timed out. WhatsApp API is experiencing delays. Please try again in a few moments.`;
          Log.error(
            `sendCreateTemplate - TIMEOUT ERROR: WhatsApp API call exceeded 60 seconds`
          );
        } else if (error.response?.status >= 500) {
          errorMessage = `WhatsApp API server error (${error.response.status}). Please try again later.`;
          Log.error(
            `sendCreateTemplate - SERVER ERROR: ${error.response.status}`
          );
        } else {
          Log.error(
            `sendCreateTemplate - ERROR:
             Message: ${error.message}
             Code: ${error.code}
             Status: ${error.response?.status || "N/A"}`
          );
        }

        return callback("", "", errorMessage, error, null);
      });
  } catch (err) {
    Log.error("sendCreateTemplate - Error Request server : " + err);
    return callback(
      "",
      "",
      "503",
      {
        message: `Service Unavailable`,
      },
      null
    );
  }
};

export const sendUpdateTemplate = async (
  jsonMessage: Object,
  whatsappBusinessID: string,
  token: string,
  templateID: string,
  callback: any
) => {
  Log.debug("MASUK sendUpdateTemplate komen");

  let url: string = env.SERVER_URL + "/whatsapp/template/update";
  const serverAccessToken = await bcrypt.hash(env.SERVER_TOKEN, 10);
  Log.debug(
    `komen sendUpdateTemplate
     - URL : ${url}
     - TOKEN : ${token} 
     - BUSINESS ID : ${whatsappBusinessID}
     - Template ID : ${templateID}`
  );
  try {
    await axios
      .post(
        url,
        { jsonMessage, whatsappBusinessID, token, templateID },
        {
          headers: {
            "Content-Type": "application/json",
            // "access_token" : token,
            Authorization: `Bearer ${serverAccessToken}`,
          },
        }
      )
      .then((response) => {
        Log.debug(
          "komen sendUpdateTemplate - Check response : " +
            JSON.stringify(response)
        );
        let isSuccess = false;
        if (response.data && response.data.responseStatus) {
          isSuccess = response.data.responseStatus;
        }
        return callback(
          isSuccess,
          response.data.responseJson,
          response.data.errorMessage ? response.data.errorMessage : "",
          response.data.errorJSON ? response.data.errorJSON : ""
        );
      })
      .catch((error) => {
        //return error callback
        Log.error(
          "sendUpdateTemplate - response : ",
          `Error Message : ${error.message} Code : ${error.code}`
        );

        return callback(false, "", error.message, JSON.stringify(error));
      });
  } catch (err) {
    Log.error("sendUpdateTemplate - Error Request server : " + err);

    return callback("", "", "503", {
      message: `Service Unavailable`,
    });
  }
};

export const createSessionUploadFileWABA = async (
  file_length: number,
  file_type: string,
  file_name: string,
  token: string
) => {
  let url: string = env.FACEBOOK_WA_CREATE_SESSION_UPLOADFILE;

  Log.debug(
    `createSessionUploadFileWABA 
    - URL : ${url}
    - TOKEN : ${token}
    - file_length : ${file_length}
    - file_type : ${file_type}
    - file_name :${file_name}`
  );

  // url = (url.replace("<<templateid>>",templateID));
  // console.log("sendUpdateTemplate - URL: "+url+" - JSON MESSAGE : "+jsonMessage+" - TOKEN : "+token);
  try {
    return await axios
      .post(url, "", {
        headers: {
          Authorization: `Bearer ` + token,
        },
        params: {
          file_length: file_length,
          file_type: file_type,
          file_name: file_name,
        },
      })
      .then((response) => {
        Log.debug(
          "createSessionUploadFileWABA - Check response : " +
            JSON.stringify(response)
        );
        return response;
      })
      .catch((error) => {
        //return error callback
        Log.error(
          "createSessionUploadFileWABA - response : ",
          `Error Message : ${error.message} Code : ${error.code}`
        );

        return error;
        // return callback(undefined,error.message, error.code, JSON.stringify(error));
      });
  } catch (err) {
    Log.error("createSessionUploadFileWABA - Error Request server : " + err);
    return {
      error: {
        message: `Service Unavailable`,
        code: `503`,
      },
    };
    // return callback("","error create session","503",{
    //       message: `Service Unavailable`,
    //     });
  }
};

export const updloadFileToWaba = async (
  ContentType: string,
  file_offset: string,
  token: string,
  binaryFile: any,
  sessionid: string
) => {
  let url: string = env.FACEBOOK_WA_UPLOADFILE_DATA;
  Log.debug(
    `uploadFileToWaba 
    - URL : ${url}
    - ContentType : ${ContentType}
    - file_offset : ${file_offset}
    - token : ${token}
    - binaryFile :${binaryFile}
    - sessionid : ${sessionid}`
  );

  url = url.replace("<<sessionid>>", sessionid);
  console.log("updloadFileToWaba - URL: " + url);
  try {
    // if(ContentType.indexOf("image")>0){
    //   //Return Image
    //   return {data: {
    //     "h": "4:bXlwcm9maWxlLmpwZw==:aW1hZ2UvanBlZw==:ARaBJZKLp_wB1eBhJvSmYF5tYtGBLMwwyPEaZgqe6qLcQQ1j2BhPHUXMKstcl5BaiqKvno3uvs2Ik7CPFrbqBywmEaK9rEkmPVVGTWMmKpwEuA:e:1664361313:1003384303873668:100081884901552:ARZt1LDLzQWAk1_kjb4"}
    //   };
    // }else if(ContentType.indexOf("video")>0){
    //   //Return Vidio
    //   return {data: {
    //     "h": "4:ZmlsZV9leGFtcGxlX01QNF80ODBfMV81TUcubXA0:dmlkZW8vbXA0:ARa5YSosL_lcdb2LEzMTLz4DsdAIT5oiNPfBliuVse3swqBa64x779RxsSW3SmOYb8zsYQ9pJn6erbusvsDCLPkLPsgyafwrPaVKTv9kijHzQw:e:1664690499:1003384303873668:100081884901552:ARYde7xByP6TC_zuI9U\n4:ZmlsZV9leGFtcGxlX01QNF80ODBfMV81TUcubXA0:dmlkZW8vbXA0:ARa5wFguhPGCC5l_H42PEtSFK_onFrP1qkbxgN01zmsXsNFkpyJ8MTR8o2klUIwRM5dIE1S5riVM9raY5OWEsmV6IKq8JeIvt-bsQUfdptPFYQ:e:1664690504:1003384303873668:100081884901552:ARbFH0Sfi_1XBuXa8ng"
    //   }};
    // }else{
    //   //Return Document
    //   return {data: {
    //     "h": "4:ZmlsZS1zYW1wbGVfMTUwa0IucGRm:YXBwbGljYXRpb24vcGRm:ARZUZ-5IbVdRSxq4N7W3Wx1J2KxGT4YAIBWPOxBdByFrxHHZnXgWID2j8WQ7c9Kp_8Iv7Pw4_S-Kw_Qdm1C2ek6pa6Nq19sTqjy_Ci_E_nixfQ:e:1664690684:1003384303873668:100081884901552:ARajOlg8gfI7hrM5_aU"
    //   }}
    // }

    return await axios.request({
      method: "POST",
      url,
      data: binaryFile,
      headers: {
        "User-Agent":
          "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/105.0.0.0 Safari/537.36",
        "Content-Type": ContentType,
        file_offset: file_offset,
        Authorization: `OAuth ` + token,
        withCredentials: false,
        // "httpAgent": new axios.Agent({ keepAlive: true }),
        // "httpsAgent" : new https.Agent({ keepAlive: true }),
      },
      transformRequest: (data: any, headers?: any) => {
        Log.debug(` transform request header ${JSON.stringify(headers)}`);
        return data;
      },
    });
  } catch (err) {
    Log.error("Error Edit Template : updloadFileToWaba " + err);
    return {
      error: {
        message: `Service Unavailable`,
        code: `503`,
      },
    };
    // return callback("","error create session","503",{
    //   message: `Service Unavailable`,
    // });
  }
};

export const sendUploadFile = async (jsonMessage: string) => {
  const url: string = env.SERVER_URL + "/facebook";
  try {
    return await axios
      .post(url, JSON.parse(jsonMessage), {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        Log.debug("Check response : " + JSON.stringify(response));
        return response;
      })
      .catch((err) => {
        return {
          error: {
            message: err.toString(),
            code: `400`,
          },
        };
      });
  } catch (err) {
    Log.error("Error Request server : " + err);
    return {
      error: {
        message: `Service Unavailable`,
        code: `503`,
      },
    };
  }
};

export const createNewProduct = async (jsonAddProduct: string) => {
  Log.debug("masuk request product ke serverside", jsonAddProduct);
  const url: string =
    env.SERVER_URL + "/7days/product/management/ShopProduct/add";
  try {
    return await axios
      .post(url, JSON.parse(jsonAddProduct), {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        Log.debug("Check response : " + JSON.stringify(response));
        return response;
      })
      .catch((err) => {
        return {
          error: {
            message: err.toString(),
            code: `400`,
          },
        };
      });
  } catch (err) {
    Log.error("Error Request server : " + err);
    return {
      error: {
        message: `Service Unavailable`,
        code: `503`,
      },
    };
  }
};

export const createNewStorefront = async (jsonAddStorefront: string) => {
  Log.debug("masuk request storefront ke serverside", jsonAddStorefront);
  const url: string =
    env.SERVER_URL + "/7days/storefront/management/ShopStorefront/add";
  try {
    return await axios
      .post(url, JSON.parse(jsonAddStorefront), {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        Log.debug("Check response : " + JSON.stringify(response));
        return response;
      })
      .catch((err) => {
        return {
          error: {
            message: err.toString(),
            code: `400`,
          },
        };
      });
  } catch (err) {
    Log.error("Error Request server : " + err);
    return {
      error: {
        message: `Service Unavailable`,
        code: `503`,
      },
    };
  }
};

export const getMarketplaceStorefront = async (dataParams: {
  account: string;
  user: string;
}) => {
  Log.debug("masuk request storefront ke serverside", dataParams);
  const url: string =
    env.SERVER_URL + "/7days/storefront/management/ShopStorefront/list";
  try {
    return await axios
      .get(url, {
        params: dataParams,
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        Log.debug("Check response : " + JSON.stringify(response));
        return response;
      })
      .catch((err) => {
        return {
          error: {
            message: err.toString(),
            code: `400`,
          },
        };
      });
  } catch (err) {
    Log.error("Error Request server : " + err);
    return {
      error: {
        message: `Service Unavailable`,
        code: `503`,
      },
    };
  }
};

export const updateMarketplaceStorefront = async (dataRequest: {
  account: string;
  user: string;
  storefront: string;
}) => {
  Log.debug("masuk request storefront ke serverside", dataRequest);
  const url: string =
    env.SERVER_URL + "/7days/storefront/management/ShopStorefront/update";
  try {
    return await axios
      .post(url, dataRequest, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        Log.debug("Check response : " + JSON.stringify(response));
        return response;
      })
      .catch((err) => {
        return {
          error: {
            message: err.toString(),
            code: `400`,
          },
        };
      });
  } catch (err) {
    Log.error("Error Request server : " + err);
    return {
      error: {
        message: `Service Unavailable`,
        code: `503`,
      },
    };
  }
};
